import React from 'react'
import {useIntl} from 'react-intl'
import {ConfirmActionSwal} from '../../../../_gori/partials/widgets'
import {AssignUserModal} from '../modals/AssignUserModal'
import {CancelOrderModal} from '../modals/CancelOrderModal'
import {HoldOrderModal} from '../modals/HoldOrderModal'
import {BatchCreationModal} from '../../batches'
import {ActionAllModal} from '../../common'
import {SET_UP_MODAL_ALL} from '../../common/core/_const'
import type {OrderModalState, OrderModalHandlers} from '../hooks/useOrderRowActions'

type OrderRowActionModalsProps = {
  dataModal: OrderModalState
  modalHandlers: OrderModalHandlers
}

const OrderRowActionModals: React.FC<OrderRowActionModalsProps> = ({dataModal, modalHandlers}) => {
  const intl = useIntl()

  return (
    <>
      {dataModal.showModal.addToBatch && (
        <BatchCreationModal
          show={dataModal.showModal.addToBatch}
          handleClose={modalHandlers.closeAddToBatch}
          orders={dataModal.addToBatch}
        />
      )}

      {dataModal.showModal.assignTo && (
        <AssignUserModal
          show={dataModal.showModal.assignTo}
          handleClose={modalHandlers.closeAssignTo}
          orders={dataModal.assignTo}
          reloadTable={modalHandlers.onAfterAssign}
        />
      )}

      {dataModal.showModal.cancelOrder && (
        <CancelOrderModal
          show={dataModal.showModal.cancelOrder}
          handleClose={modalHandlers.closeCancelOrder}
          orders={dataModal.cancelOrder}
          reloadTable={modalHandlers.onAfterCancel}
        />
      )}

      {dataModal.showModal.holdOrder && (
        <HoldOrderModal
          show={dataModal.showModal.holdOrder}
          handleClose={modalHandlers.closeHoldOrder}
          orders={dataModal.holdOrder}
          reloadTable={modalHandlers.onAfterHold}
        />
      )}

      {dataModal.showModal.requestRefund && (
        <ConfirmActionSwal
          show={dataModal.showModal.requestRefund}
          title={intl.formatMessage({id: 'REFUND_REQUEST'})}
          message={intl.formatMessage({id: 'ARE_YOU_SURE'})}
          messageCancel={intl.formatMessage({id: 'NO'})}
          handleCallBack={modalHandlers.confirmRefund}
          handleClose={modalHandlers.closeRequestRefund}
        />
      )}

      {dataModal.showModal.requestRefundAction && (
        <ActionAllModal
          show={dataModal.showModal.requestRefundAction}
          data={dataModal.requestRefund}
          setUpModal={SET_UP_MODAL_ALL.REFUND_REQUEST}
          handleClose={modalHandlers.closeRequestRefundAction}
        />
      )}
    </>
  )
}

export {OrderRowActionModals}
